export default Vue => {
  Vue.component("v-map", () => import("./v-map.vue"));
  Vue.component("v-map-popup", () => import("./v-map-popup.vue"));
};
